export class ExternalMenuParameterSource {
  userId: string;
  userName: string;
  departmentId: string;
  orderUserId: string;
  attendingUserId: string;
  patientId: string;
  clientIpAddress: string;
  hostName: string;
  documentId: number;
}
